import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { map, filter } from 'rxjs/operators';

export type Payload = any;
export interface EventBusMessage {
    channel: string;
    payload: Payload;
}

@Injectable()
export class EventBusService1 {
    public listen: Observable<Payload>;

    private next;
    constructor() {
        this.listen = new Observable(observer => {
            this.next = (payload: Payload) => observer.next(payload);
            return _ => _ /* nothing to clean */;
        });
        this.channelEmmiter = this.channelEmmiter.bind(this);
        this.emit = this.emit.bind(this);
    }

    allChannels(): Observable<EventBusMessage> {
        return this.listen;
    }

    channel(channelName: string): Observable<Payload> {
        return this.listen
            .pipe(filter(e => e.channel === channelName),
                map(e => e.payload));
    }

    channelEmmiter(channelName) {
        console.log('made listener for', channelName);
        return (payload: Payload): void => {
            this.emit({ channel: channelName, payload });
        };
    }

    emit({ channel, payload }: EventBusMessage): void {
        console.log('emit', channel);
        this.next({ channel, payload });
    }
}

/**
 * Global EventEmitter
 */
@Injectable()
export class EventBusService<Events = any> {
    /** Map event name to Subject  */
    private _subjects = new Map<Events, Subject<any>>();

    /**
     *
     * @param eventName
     * @param handler
     * @returns
     */
    on(eventName: Events, handler: (data: any) => any) {
        if (!this._subjects.has(eventName)) {
            this._subjects.set(eventName, new Subject());
        }
        const _subject = this._subjects.get(eventName);
        const subscription = _subject.subscribe(handler);
        return {
            unsubscribe: () => {
                subscription.unsubscribe();
                if (_subject.observers.length > 0) {
                    this._subjects.delete(eventName);
                }
            }
        };
    }

    /**
     *
     * @param eventName
     * @param data
     */
    emit(eventName: Events, data) {
        if (this._subjects.has(eventName)) {
            this._subjects.get(eventName).next(data);
        }
    }

    /**
     * Destory all subscription and clear the map
     */
    destroy() {
        this._subjects.forEach((subject, _) => {
            subject.unsubscribe();
        });
        this._subjects.clear();
    }
}

